import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './FAQSection.css';

const FaqItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  
  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button
        onClick={() => setOpen(!open)}
        className="faq-btn"
      >
        <span className="faq-question">{question}</span>
        <div className="faq-icon-box">
          <FaChevronDown />
        </div>
      </button>
      <div className="faq-body">
        <div className="faq-content">
          <p className="faq-text">{answer}</p>
        </div>
      </div>
    </div>
  );
};

const defaultFaqs = [
  { q: 'What is Naukri Platform and how does it help employers?', a: 'Naukri Platform is a job portal that helps employers connect with skilled candidates through job postings, targeted hiring, and recruitment support.' },
  { q: 'Who can post jobs on Naukri Platform?', a: 'Startups, SMEs, corporates, HR professionals, and individual recruiters can all post jobs on the platform.' },
  { q: 'Is there a free job posting option available?', a: 'Yes, employers can post jobs for free and start receiving applications without any initial cost.' },
  { q: 'What are the limitations of free job postings?', a: 'Free job posts have limited visibility and reach a broader, less targeted audience, which may result in slower hiring.' },
  { q: 'What benefits do paid job postings offer?', a: 'Paid plans provide: Featured listings, Targeted candidate reach, Higher visibility, and Faster response rates.' },
];

const FAQSection = ({ 
  title = "Got Questions?", 
  subtitle = "Common questions about posting jobs and hiring on Naukri Platform.",
  faqs = defaultFaqs
}) => {
  return (
    <section className="faq-section-wrapper">
      <div className="faq-banner">
        <div className="faq-banner-icon">💬</div>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="faq-list">
        {faqs.map((faq, i) => (
          <FaqItem key={i} question={faq.q} answer={faq.a} />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
